"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _helpers = require("../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const mapStateToProps = (state, props) => {
  return {
    [props.entity.plural]: state[props.entity.plural]
  };
};
const mapDispatchToProps = (dispatch, props) => {
  return {
    update: (0, _redux.bindActionCreators)(props.actions.update, dispatch, module)
  };
};
class BaseEdit extends _react.default.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      [this.props.singular]: null,
      messages: []
    });
    _defineProperty(this, "handleChange", body => {
      const {
        singular
      } = this.props.entity;
      this.setState({
        [singular]: {
          ...this.state[singular],
          ...body
        }
      });
    });
    _defineProperty(this, "handleSubmit", event => {
      event.preventDefault();
      const {
        entity,
        history,
        update,
        [this.props.entity.plural]: store
      } = this.props;
      const onSuccess = store.edit && store.edit.onSuccess ? store.edit.onSuccess : undefined;
      update(this.props[entity.singular].data.Id, this.state[entity.singular], {
        expand: store.expand
      }, module).then(response => {
        /*
        				this.clearMessages();
        
        				this.addMessage({text: 'The data was successfully modified!', type: 'success'});
        */
        onSuccess ? onSuccess(this.props) : history.push(`/${entity.plural}/${response.Id}`);
      }).catch(error => {
        this.clearMessages();
        console.dir(error);
        this.addMessage({
          text: error.Message,
          type: 'error'
        });
      });
    });
    _defineProperty(this, "clearMessages", () => this.setState({
      messages: []
    }));
    _defineProperty(this, "addMessage", message => this.setState({
      messages: [...this.state.messages, message]
    }));
    _defineProperty(this, "render", () => {
      const {
        children,
        entity,
        [this.props.entity.plural]: store,
        ...rest
      } = this.props;
      return _react.default.cloneElement(children, {
        ...rest,
        [entity.singular]: this.props[entity.singular],
        state: this.state[entity.singular],
        messages: this.state.messages,
        fields: {
          rows: (0, _helpers.objectToArray)(store.edit.schema)
        },
        schema: store.edit.schema,
        onChange: this.handleChange,
        onSubmit: this.handleSubmit
      });
    });
  }
  componentDidMount() {
    const {
      singular
    } = this.props.entity;
    if (!this.state[singular] && this.props[singular].fetched) {
      this.setState({
        [singular]: this.props[singular].data
      });
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      singular
    } = this.props.entity;
    if (this.props[singular].fetched !== nextProps[singular].fetched) {
      this.setState({
        [singular]: nextProps[singular].data
      });
    }
  }
}
BaseEdit.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.element.isRequired
} : {};
var _default = exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BaseEdit);
module.exports = exports.default;